<template>
  <div class="loader" v-if="loader">
    <img src="../assets/img/loader.svg" alt="loading">
    <div class="loader-span">
      <div class="span"></div>
    </div>
    <div class="loader-text">
      Never miss a deal again with Cashback Alert
    </div>
  </div>
  <div class="wrapper" :class="{'popup-open': popupOpen || $route.params.storeId, 'offers': openStoreExt}" v-else>
    <div class="header-sticky">
      <Header :settings="settings"
              :savedIsOpen="savedOpen"
              :storeInExt="openStoreExt"
              :settingsOpen="settingsOpen"
              v-on:togglesaved="toggleSavedOpen"
              v-on:settingstoggle="settingsToggle"
      />
      <Search
          :relevantList="storesFound"
          v-on:openstore="openStore"
          v-on:searchstore="searchStores"
      />
    </div>
    <div class="banner" v-if="this.isWideScreen">
      <a :href="appLink" v-if="settings.extensionInstalled">
        <img src="../assets/img/banner.svg" alt="categories" >
      </a>
      <a :href="isEdge ? edgeLink : chromeLink" v-else>
        <img src="../assets/img/install-extension-banner.png" alt="categories">
      </a>
    </div>
    <div class="nav">
      <div class="filters-breadcrumbs-block">
        <button class="nav-btn" @click="showFilters = true">
          <img class="mr-12" src="../assets/img/bx_bxs-category.svg" alt="categories">
          Filters
        </button>
        <div class="filters-breadcrumbs" v-if="activeCategoryName">
          <button class="btn-link" @click="clearFilters">
            <img src="../assets/img/eva_arrow-ios-forward-outline-left.svg" alt="forward left" >
          </button>
          {{activeCategoryName}}
          <span v-if="activeSubCategoryName && activeSubCategoryName !== ''">&nbsp;->&nbsp;</span> {{activeSubCategoryName}}
        </div>
      </div>
      <div class="nav-sort">
        <span class="nav-label">Sort by</span>
        <button class="nav-btn dropdown" @click="sortingOpen = !sortingOpen">
          {{ activeSorting.name }}
          <img class="ml-12" src="../assets/img/arrow-down.svg" alt="arrow">
        </button>
        <div ref="sort" class="sort-list panel" v-if="sortingOpen" v-click-outside="hideSorting">
          <div
              class="sort-item"
              :class="{active: activeSorting.name === item.name}"
              v-for="(item, index) in sorting"
              :key="index"
              @click="sortStores(item)"
          >
            {{item.name}}
          </div>
        </div>
      </div>
    </div>

    <div class="saved" :class="{active: savedOpen}">
      <div class="title main-setting-title">
        <a href="#" class="back-to-result" @click.prevent="toggleSavedOpen"></a>
        Saved deals
      </div>
      <div class="promocode" v-if="saved.length">
        <StoreItem
            v-for="item in saved"
            :key="item.id"
            :saved="saved"
            v-on:openstore="openStore"
            v-on:changesaved="changeSaved"
            v-bind="item"/>
      </div>
    </div>
    <div class="promocode" v-if="stores">
      <StoreItem
          v-for="(item, index) in stores"
          :key="index"
          :saved="saved"
          v-on:openstore="openStore"
          v-on:changesaved="changeSaved"
          v-bind="item"/>
      <div class="text-center w-100 more-wrapper" v-if="showMoreBtn">
        <button class="btn-main -large" @click="loadMoreStores">
          <span class="lds-dual-ring" v-if="moreStoresLoader"></span> <span v-else>Show +{{ storesLimit }} more</span>
        </button>
      </div>
      <div class="w-100 more-wrapper text-center more-wrapper-center" v-if="!stores.length && !moreStoresLoader">
        <h2>There is no cashback for current filters</h2>
      </div>
    </div>
<!--    <Store v-if="storeOpen"
      :storeIsOpen="storeOpen"
      :storeData="activeStore"
      :storeInExt="openStoreExt"
      v-on:closestore="closeStore"
      v-on:opendeal="openDeal"
      v-on:changesaved="changeSaved"
      v-on:closedeal="dealOpen = false"
    />-->
    <router-view
        :storeData="activeStore"
        :storeInExt="openStoreExt"
        v-on:opendeal="openDeal"
        v-on:closedeal="dealOpen = false"
        v-on:setActiveStore="activeStore = $event"
        v-on:changesaved="changeSaved"
    />
    <Settings :open="settingsOpen"
              :settings="settings"
              v-on:refreshdeals="refreshStores"
              v-on:settingstoggle="settingsToggle"
    />
    <transition name="fade">
      <Filters v-if="showFilters"
               :cashbackValue="filters.cashbackValue"
               :couponsfilter="filters.couponsFilter"
               :categories="categories"
               :activeCategory="activeCategory"
               :activeSubCategory="activeSubCategory"
               :isWideScreen="this.isWideScreen"
               @closeFilters = "showFilters = false; resetFilters = false"
               @changeFilters = "updateFilters"
      />
    </transition>
    <transition name="fade">
      <GetCode v-if="dealOpen"
               :deal="activeDeal"
               :storeHost="activeStore.host"
         v-on:opendeal="dealOpen = true"
         v-on:closedeal="dealOpen = false"
      />
    </transition>
    <div class="return-to-top back-top" @click="scrollToTop" v-if="showScrollTop">
      <i class="fa fa-chevron-up"></i>
    </div>
  </div>
  <Footer v-if="this.isWideScreen"/>
  <Thanks
      v-if="thanksPopupShow"
      v-on:closethanks="thanksPopupShow = false; removeModalBg()"
  />
</template>

<script>
import vClickOutside from 'click-outside-vue3'
import Thanks from './Thanks'
import Settings from './Settings'
import Header from './Header'
import Search from "@/components/Search";
import StoreItem from "@/components/StoreItem";
import Filters from "@/components/Filters";
import Footer from "@/components/Footer";
import "../assets/styles/base.scss";
import GetCode from "@/components/GetCode";
import {performRequest} from "../api";
import {MAIN_API_URL, reportEvent, chromeExtensionLink, edgeExtensionLink, mobileAppLink} from "../utils";

export default {
  name: 'Main',
  data: function () {
    return {
      loader: true,
      moreStoresLoader: false,
      stores: null,
      categories: null,
      showFilters: false,
      thanksPopupShow: false,
      storesFound: [],
      settings: {
        extensionInstalled: false,
        autoDetect: true,
        enableNotification: true,
        lastRefresh: localStorage.getItem('lastrefresh') || null
      },
      sortingOpen: false,
      savedOpen: false,
      settingsOpen: false,
      storesLimit: 12,
      sorting:[
        {
          name: 'Recommended',
          selected: true,
        },{
          name: 'Top cashback',
          selected: false,
        },{
          name: 'Top coupons',
          selected: false,
        },
      ],
      showMoreBtn: false,
      popupOpen: false,
      storeOpen: false,
      openStoreExt: false,
      dealOpen: false,
      activeStore: null,
      saved: localStorage.getItem('saved') ? JSON.parse(localStorage.getItem('saved')) : [],
      activeCategory: null,
      activeSubCategory: null,
      activeDeal: null,
      filters: {
        activeSubCategories: null,
        cashbackValue: 'all',
        couponsFilter: 'all',
      },
      isFirstRequest: true,
      pagination: {
        page: 1,
      },
      sortingRequest: 'recommended',
      showScrollTop: false,
      activeCategoryName: false,
      activeSubCategoryName: false,
    }
  },

  created() {
    this.appLink = mobileAppLink
    this.chromeLink = chromeExtensionLink
    this.edgeLink = edgeExtensionLink
    fetch('chrome-extension://hmjpgkijcofiemaehljjmjfdellejpla/icons/cashback-icon.png')
        .then(res=> {
          if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
          } else {
            console.log('Extension installed')
          }
        }).catch(e => {
          console.error(e);
        })

    this.isWideScreen = window.matchMedia('(min-width: 1100px)').matches
    this.isEdge = window.navigator.userAgent.indexOf("Edg") > -1
  },
  computed: {
    activeSorting() {
      return this.sorting.find(sortValue => sortValue.selected)
    },
  },
  methods: {
    clearFilters(){
      this.activeSubCategoryName = ''
      this.activeCategoryName = ''
      this.stores = null
      this.fetchStores({limit: this.storesLimit})
    },
    loadMoreStores(){
      this.isFirstRequest = false;
      this.fetchStores({
        limit: this.storesLimit,
        page: ++this.pagination.page,
        categories: this.filters.activeSubCategories && this.filters.activeSubCategories.length ? this.filters.activeSubCategories : null,
        cashback_max: this.filters.cashbackValue === 'all' ? null : this.filters.cashbackValue,
        has_coupons: this.filters.couponsFilter === 'all' ? null : this.filters.couponsFilter === 'with' ? 1 : '0',
        sort: this.sortingRequest
      })
    },
    sortStores(item){
      this.sorting.forEach(sortingOption => sortingOption.selected = sortingOption.name === item.name);
      this.sortingOpen = false
      this.pagination.page = 1
      this.stores = []
      this.sorting.forEach(sortingOption => {
        if (sortingOption.selected){
          switch (sortingOption.name){
            case 'Recommended': this.sortingRequest = 'recommended';
              break
            case 'Top cashback': this.sortingRequest = 'top_cashback'
              break
            case 'Top coupons': this.sortingRequest = 'top_coupons'
              break
          }
        }
      })
      this.fetchStores({limit: 12, sort: this.sortingRequest})
      reportEvent('sort', {
        sortname: this.sortingRequest
      })
    },
    searchStores(searchValue){
      this.fetchStores({
        limit: 100,
        search: searchValue
      }, null, true)
    },
    addModalBg(){
      document.body.classList.add('overflow-hidden')
      this.popupOpen = true
    },
    removeModalBg(){
      document.body.classList.remove('overflow-hidden')
      this.popupOpen = false
    },
    settingsToggle(value){
      this.settingsOpen = value
      value ? this.addModalBg() : this.removeModalBg()
    },
    openStore (data) {
      // this.storeOpen = true
      this.$router.push('/store/' + data.id)
      this.activeStore = data
      this.activeStore.isFavorite = this.saved.some(item => item.name === data.name);
      // this.addModalBg()
    },
    closeStore () {
      this.savedOpen = false
      this.storeOpen = false
      this.activeStore = null
      this.removeModalBg()
    },
    hideSorting () {
      this.sortingOpen = false
    },
    toggleSavedOpen () {
      this.savedOpen = !this.savedOpen
      this.storeOpen = false
      this.savedOpen ? this.addModalBg() : this.removeModalBg()
    },
    changeSaved (savedItems) {
      localStorage.setItem('saved', JSON.stringify(savedItems))
      this.saved = savedItems
    },
    updateFilters (filters, cat, subcat) {
      this.activeCategoryName = cat
      this.activeSubCategoryName = subcat
      this.activeCategory = filters && filters.activeCategory ? filters.activeCategory : null
      this.activeSubCategory = filters && filters.activeSubCategory ? filters.activeSubCategory : null
      this.filters = filters
      this.pagination.page = 1
      this.stores = []
      this.fetchStores({
        limit: 12,
        page: this.pagination.page,
        categories: this.filters.activeSubCategories.length ? this.filters.activeSubCategories : null,
        cashback_max: this.filters.cashbackValue === 'all' ? null : this.filters.cashbackValue,
        has_coupons: this.filters.couponsFilter === 'all' ? null : this.filters.couponsFilter === 'with' ? 1 : '0',
      })
    },
    openDeal(dealFull){
      this.activeDeal = dealFull
      this.dealOpen = true
    },
    fetchStores (setting, firstRequest, isSearch) {
      const url = new URL(MAIN_API_URL+'get_store')
      Object.keys(setting).forEach(key => {
        if(setting[key]){
          url.searchParams.append(key, setting[key])
        }
      })
      this.loader = !!firstRequest
      this.moreStoresLoader = !firstRequest
      performRequest(
          url,
          {
            method: 'POST',
          }
      ).then(res => {
        this.showMoreBtn = res.data.stores.length > 11
        if(isSearch){
          this.storesFound = res.data.stores
        } else {
          this.stores = this.stores ? this.stores.concat(res.data.stores) : res.data.stores
        }
        console.log(this.stores);
        this.settings.lastRefresh = this.getRefreshDate(res.refreshing_date)
        localStorage.setItem('lastrefresh', this.settings.lastRefresh)
        this.loader = false
        this.moreStoresLoader = false
      }).catch((error) => {
        console.error('Error:', error);
      })
    },
    refreshStores() {
      this.fetchStores({limit: this.storesLimit}, this.isFirstRequest)
      this.settingsOpen = false
      this.removeModalBg()
    },
    getRefreshDate(date){
      const timeNow = new Date(date)
      const dayNow = new Date().getDay()
      const hourNow = timeNow.getHours().toString().length === 1 ? '0' + timeNow.getHours() : timeNow.getHours()
      const minNow = timeNow.getMinutes().toString().length === 1 ? '0' + timeNow.getMinutes() : timeNow.getMinutes()
      const isToday = dayNow === timeNow.getDay() ? 'Today' : timeNow.getMonth() + 1 + '/' + timeNow.getDate() + '/'+ timeNow.getUTCFullYear()
      return isToday + ' at ' + hourNow + ':'+ minNow
    },
    scrollToTop () {
      const body = document.querySelector('body')
      body.scrollIntoView({behavior: "smooth"})
    }
  },
  mounted () {
    window.document.onscroll = () => {
      this.showScrollTop = window.scrollY > 300;
    }
    const today = new Date().getTime()
    let timeToUpdate = localStorage.getItem('timetoupdate') ? JSON.parse(localStorage.getItem('timetoupdate')) : today + 86400000
    localStorage.setItem('timetoupdate', timeToUpdate)
    if (this.stores){
      this.loader = false
    }

    if (!this.categories) {
      performRequest(
          MAIN_API_URL + 'get_categories',
          {
            method: 'POST'
          }
        ).then(res => {
        this.categories = res.data.categories;
      })
    }

    if (today > timeToUpdate) {
      this.refreshStores()
      console.log('update');
      localStorage.setItem('timetoupdate', (today + 86400000).toString())
    } else {
      this.fetchStores({limit: this.storesLimit}, this.isFirstRequest)
    }

    const openStoreId = this.$route.query.store;

    if (openStoreId) {
      this.$router.push('/store/' + openStoreId);
    }

    if (this.$route.query.thanks){
      this.thanksPopupShow = true
      window.fbq('track', 'Install');
      this.addModalBg()
      this.$router.replace({'thanks': null});
    }

    if (this.$route.query.floatpopup){
      this.activeStore = this.$route.query.id
      this.floatPopupShow = true
      this.$router.replace({'floatpopup': null});
    }

    window.onmessage = (e) => {
      if (e.data.sender === 'cs') {
        Object.assign(this.settings, e.data.message, {
          extensionInstalled: true,
        })
      }
    }

    window.postMessage({
          sender: 'caSite',
          message: {
            ping: true
          },
        },
        "*")

  },
  components: {
    GetCode,
    StoreItem,
    Search,
    Header,
    Filters,
    Settings,
    Footer,
    Thanks,
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
}

</script>

<style lang="scss">

.nav-sort {
  position: relative;
}

.sort-list {
  position: absolute;
  top: 110%;
  right: 0;
  z-index: 4;
  font-size: 14px;
  border-radius: 8px;

  &.panel {
    padding: 8px 0;
  }
}

.sort-item {
  cursor: pointer;
  padding: 6px 16px;
  font-weight: bold;

  &.active {
    pointer-events: none;
    background-color: rgba(75, 46, 255, 0.08);
  }

  &:hover {
    background-color: #f6f6f7;
  }
}

.nav-btn {
  display: flex;
  align-items: center;
  padding: 7px 12px 7px 12px;
  color: #514E68;
  font-size: 14px;
  font-weight: bold;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  border: 0;
}
</style>
